import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StorageService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService
  ) { }

  canActivate(): boolean | UrlTree {
    return this.storageService.get('isLoggedIn')
      ? true
      : this.router.createUrlTree(['/login']);
  }

  canActivateChild(): boolean | UrlTree {
    return this.canActivate();
  }
}

@Injectable({ providedIn: 'root' })
export class OtpGuard {
  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService
  ) { }

  canActivate(): boolean | UrlTree {
    if (this.storageService.get('isLoggedIn')) {
      return this.router.createUrlTree(['/profile-setting']);
    }

    const pending = this.storageService.get('otpPending');
    const userId = this.getUserId();

    return pending && userId ? true : this.router.createUrlTree(['/login']);
  }

  private getUserId(): string | null {
    try {
      const raw = this.storageService.get('userDetail');
      return raw ? JSON.parse(raw)?.userId ?? null : null;
    } catch {
      return null;
    }
  }
}

@Injectable({ providedIn: 'root' })
export class SessionGuard {
  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService
  ) { }

  canActivate(): boolean | UrlTree {
    if (this.storageService.get('isLoggedIn')) {
      return this.router.createUrlTree(['/profile-setting']);
    }
    return true;
  }
}

